import html from "./CaptureStep.html"
import "./CaptureStep.css"

var module = angular.module("ResearchKitApplicationModule");

module.directive("captureStep",
	function () {
		return {
			template: html,
			replace: false,
			restrict: "E",
			scope: {
				"stepManager": "="
			}
		};
	}
);

module.controller("captureStepController", ["$scope",
	function ($scope) {
		$scope.fileChanged = function (event) {
			var file = event.target.files[0];

			var renamedFile = new File([file], $scope.stepManager.step.identifier + "." + file.name.split('.').pop(), { type: file.type });

			$scope.stepManager.childResults[0].ContentType = renamedFile.type;
			$scope.stepManager.childResults[0].FileName = renamedFile.name;
			$scope.stepManager.childResults[0].File = renamedFile;

			readFile(renamedFile);
		};

		if ($scope.stepManager?.childResults?.[0]?.File) {
			readFile($scope.stepManager.childResults[0].File);
		}

		function readFile(file) {
			var reader = new FileReader();
			reader.onload = function (data) {
				var src = data.target.result;
				$scope.$apply(function () {
					$scope.selectedFileUrl = src;
				});
			};
			reader.readAsDataURL(file);
		}
	}]);

module.directive('customFileOnChange', function () {
	return {
		restrict: 'A',
		link: function (scope, element, attrs) {
			var onChangeHandler = scope.$eval(attrs.customFileOnChange);
			element.on('change', onChangeHandler);
		}
	};
});

module.factory("ImageCaptureStepManager", ["StepManager", function (StepManager) {
	function ImageCaptureStepManager(step, previousResult, surveyManager) {
		StepManager.call(this, step, previousResult, surveyManager);
	}
	ImageCaptureStepManager.prototype = Object.create(StepManager.prototype);

	ImageCaptureStepManager.prototype.hasAnswer = function () {
		var result = this.getChildResult(this.step.identifier);
		if (!result) return false;

		if (result.hasOwnProperty("ContentType") && result.hasOwnProperty("FileName")) {
			return result.ContentType && result.FileName;
		}
		return false;
	};

	ImageCaptureStepManager.prototype.initializeResults = function (previousResult) {
		StepManager.prototype.initializeResults.call(this, previousResult);

		if (previousResult && previousResult.Files && previousResult.Files[0]) {
			this.files = previousResult.Files;
		}

		if (!this.childResults.length) {
			this.childResults = [
				{
					Identifier: this.step.identifier,
					Type: "FileResult",
					StartDate: this.presentedDate
				}
			];
		}
	};

	return ImageCaptureStepManager;
}]);